import { omit } from 'lodash';

import {
  CancelStatusDetails,
  DisputeStatusDetails,
  OrderStatus,
  OrderStatusReason,
  PayoutCancelStatusDetails,
  PayoutDisputeStatusDetails,
  PayoutManualStatusDetails,
  PayoutOrderStatus,
  PayoutOrderStatusDetails,
  PayoutRejectStatusDetails,
} from 'enums';

export const TRADER_SELECT_DISPUTE_DETAILS = [
  DisputeStatusDetails.DisputeNoPayment,
  DisputeStatusDetails.DisputeDifferentAmount,
] as DisputeStatusDetails[];

export const PAYOUT_DISPUTE_SELECT_DETAILS = [
  PayoutDisputeStatusDetails.DisputeInvalidRequisites,
  PayoutDisputeStatusDetails.DisputePaymentFailed,
];

export const PAYOUT_REJECT_SELECT_DETAILS = [
  PayoutRejectStatusDetails.RejectNoFunds,
  PayoutRejectStatusDetails.RejectPaymentImpossible,
  PayoutRejectStatusDetails.RejectRequisitesBlocked,
];

export const ORDER_WITH_RECEIPTS_STATUSES = [
  OrderStatus.CustomerConfirm,
  OrderStatus.TraderConfirm,
  OrderStatus.Completed,
  OrderStatus.Cancelled,
  OrderStatus.Dispute,
  OrderStatus.Error,
];

export const VISIBLE_CANCEL_STATUS_DETAILS = omit(CancelStatusDetails, [
  CancelStatusDetails.CancelledRequisitesVerificationOrder,
]);

export const MERCHANT_ORDER_STATUSES = [
  OrderStatus.HoldCompleted,
  OrderStatus.Completed,
  OrderStatus.Cancelled,
  OrderStatus.Dispute,
];

export const MERCHANT_PAYOUT_ORDER_STATUSES = [
  PayoutOrderStatus.Requisites,
  PayoutOrderStatus.TraderPayment,
  PayoutOrderStatus.Completed,
  PayoutOrderStatus.Cancelled,
  PayoutOrderStatus.Dispute,
];

export const TRADER_ORDER_STATUSES = [
  OrderStatus.CustomerConfirm,
  OrderStatus.TraderConfirm,
  OrderStatus.Completed,
  OrderStatus.HoldCompleted,
  OrderStatus.Cancelled,
  OrderStatus.Dispute,
  OrderStatus.Error,
];

export const TRADER_PAYOUT_ORDER_STATUSES = [
  PayoutOrderStatus.Requisites,
  PayoutOrderStatus.TraderPayment,
  PayoutOrderStatus.Completed,
  PayoutOrderStatus.Cancelled,
  PayoutOrderStatus.Dispute,
];

export const DEPRECATED_PAYOUT_ORDER_STATUSES = [
  PayoutOrderStatus.TraderAccept,
];

const MINUTE = 60 * 1000;
export const DEFAULT_PAYOUT_MAX_TIMEOUT = 60;
export const PAYIN_DISPUTE_ALERT_AFTER = 30 * MINUTE;
export const HIDE_PAYOUT_TIMER_IN_STATUSES = [
  PayoutOrderStatus.Cancelled,
  PayoutOrderStatus.Completed,
  PayoutOrderStatus.Error,
];

export const DEFAULT_ASSET_CURRENCY_CODE = 'USDT';

export const ACTIVE_PAYOUT_ORDERS_STATUSES = [
  PayoutOrderStatus.New,
  PayoutOrderStatus.Requisites,
  PayoutOrderStatus.TraderPayment,
];

/** Mirrors MANUAL_BATCH_MAX_ORDERS on the backend — one manual operation is capped at 150. */
export const MANUAL_BATCH_MAX_ORDERS = 150;

export const MANUAL_PAYOUT_STATUS_DETAILS = [
  PayoutManualStatusDetails.ManualPending,
  PayoutManualStatusDetails.ManualFailed,
];

/**
 * Sub-states an order can only reach while manual payout distribution is on. They stay out of
 * shared filters when the feature is off — nothing can enter them, so offering them is noise.
 */
export const MANUAL_DISTRIBUTION_ONLY_STATUS_DETAILS: PayoutOrderStatusDetails[] =
  [
    ...MANUAL_PAYOUT_STATUS_DETAILS,
    PayoutCancelStatusDetails.CancelledManualTimeout,
  ];

export const OPEN_DISPUTE_ORDER_STATUS_REASONS = [
  OrderStatusReason.WaitingTrader,
  OrderStatusReason.WaitingMerchant,
];

export const DISPUTE_TO_COMPLETED_ORDER_STATUS_REASONS = [
  OrderStatusReason.RepeatPayment,
  OrderStatusReason.DifferentAmount,
];
